<template>
  <div class="modal-container" :class="{ full: fullSize }">
    <div class="overlay" @click="!props.fullSize && emit('close')" />
    <div class="dialog">
      <div class="content">
        <div class="header">
          <slot name="header">
            <span class="slot-header">
              {{ title }}
            </span>
          </slot>
          <UiIcon
            name="close"
            class="close-icon"
            :is-clickable="true"
            @click="emit('close')"
          />
        </div>
        <div class="body">
          <slot name="body"></slot>
        </div>
        <div class="footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import UiIcon from '@sephora-asia/ui-icon/UiIcon.vue'
import type { Props } from './types'

const props = withDefaults(defineProps<Props>(), {
  title: '',
  fullSize: false,
  width: '600px',
})

const emit = defineEmits(['close'])
</script>

<style lang="scss" scoped>
.modal-container {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: var(--size-z-index-modal-backdrop);

  .overlay {
    background-color: var(--color-base-black);
    bottom: 0;
    left: 0;
    opacity: 0.6;
    position: fixed;
    right: 0;
    top: 0;
    z-index: var(--size-z-index-modal-backdrop);
  }

  .dialog {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    margin: 16px;
  }

  .content {
    background-color: var(--color-base-white);
    border-radius: 8px;
    outline: 0;
    padding: 0 24px;
    pointer-events: auto;
    z-index: var(--size-z-index-modal);
    width: v-bind(width);

    @include mobile {
      padding: 0 16px;
    }
  }

  .header {
    align-items: center;
    display: flex;
    justify-content: space-between;
    text-transform: capitalize;
    margin-top: 24px;

    @include mobile {
      margin-top: 16px;
    }

    .slot-header {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .close-icon {
      --icon-size: 24px;
    }

    @extend .headline-l;
  }

  .body {
    display: flex;
    margin: 16px 0 24px;

    @include mobile {
      margin: 16px 0;
    }
  }

  &.full {
    .dialog {
      margin: 0;
    }

    .content {
      border-radius: unset;
      height: 100%;
      box-sizing: border-box;
      width: 100%;
    }
  }
}
</style>
